import React from 'react';

export default () => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Group 2</title>
    <g stroke="#46C3F1" strokeWidth="2" fill="none" fillRule="evenodd">
      <circle cx="18" cy="18" r="17" />
      <path d="M10 18h16" strokeLinecap="square" />
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/icons/FlashMinus.jsx